import React, { useEffect, useState } from "react";
import { GetServiceGroups } from "../../hooks/useServiceData";
import { ServiceGroupTableHeadCells } from "../../constants/ServiceGroupConstants";
import GeneralTable from "../GeneralTable";

export const ServiceGroupTable = (props) => {
  const [serviceGroups, setServiceGroups] = useState([]);

  const { data } = GetServiceGroups();

  useEffect(() => {
    let serviceGroupList = [];

    if (data?.data) {
      serviceGroupList = data?.data.map((serviceGroup) => {
        return {
          id: serviceGroup.id,
          owner_id: serviceGroup.owner_id,
          name: serviceGroup.name,
          cost: serviceGroup.cost,
          account: serviceGroup.account.number,
          isActive: serviceGroup.isActive === 1 ? "Aktiv" : "Inaktiv",
        };
      });
      setServiceGroups(serviceGroupList);
    }
  }, [data]);

  return (
    <>
      <GeneralTable
        headCells={ServiceGroupTableHeadCells}
        rows={serviceGroups}
        handleSelect={props.handleSelect}
      />
    </>
  );
};
